<template>
  <div id="app">
    <div class="container-fluid pt-5">
      <div class="row justify-content-center align-items-center">
        <div class="col-6">
          <span class="h2">{{ appName }}</span>
          <img src="../public/images/vivofacil-logo.png" alt="Logo VivoFácil" class="img-fluid" width="20%">
        </div>
        <div class="col-2">
          <button class="btn btn-link text-secondary float-right" v-if="isAuthenticated" @click="logout">
            <i class="fa fa-sign-out"></i>&nbsp;Salir
          </button>
        </div>
      </div>
    </div>

    <div class="container-fluid">
      <login v-if="!isAuthenticated" @login-success="handleLoginSuccess" />
      <search v-else @token-expired="handleTokenExpired"></search>
    </div>
  </div>
</template>

<script>
import Search from "@/components/Search.vue";
import Login from "@/components/Login.vue";

export default {
  name: 'App',
  components: {
    Search,
    Login
  },
  data() {
    return {
      isAuthenticated: false,
      appName: process.env.VUE_APP_TITLE
    }
  },

  mounted() {
    this.checkAuthentication();
  },

  methods: {
    checkAuthentication() {
      const token = localStorage.getItem('authToken');
      this.isAuthenticated = !!token;
    },

    handleLoginSuccess() {
      this.isAuthenticated = true;
    },

    handleTokenExpired() {
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      this.isAuthenticated = false;
    },

    logout () {
      localStorage.removeItem('authToken');
      localStorage.removeItem('user');
      this.isAuthenticated = false;
    },
  }
}
</script>
